import { Document } from '@klubovna/api-client';
import { PaginationMetadata } from '@shared';

export interface DocumentsState {
  documents: Document[];
  loading: boolean;
  error: string | null;
  pagination: PaginationMetadata;
}

export const initialDocumentsState: DocumentsState = {
  documents: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};
